/**
 * Utility function to extract query parameters from URL,
 * store specific parameters in localStorage, and remove them from URL
 * @returns Object containing the extracted clientId and uinIds and validation status
 */

import { setStorage, getStorage } from "../services/storageService";

export const handleUrlParams = () => {
  // Get the current URL
  const url = new URL(window.location.href);
  const params = url.searchParams;
 
  
  // Check if client_id parameter exists in URL
  let clientId = params.get('client_id');
  
  // Check if uin parameter exists and extract uin values
  const uinParam = params.get('uin_ids');
  let uinIds: string[] = [];
  
  if (uinParam) {
    // Split the uin parameter by comma and add each value to the uinIds array
    uinParam.split(',').forEach(uid => {
      if (uid.trim()) {
        uinIds.push(uid.trim());
      }
    });
  }
  
  // If parameters aren't in URL, check localStorage
  if (!clientId) {
    clientId = getStorage('client_id');
  }
  
  if (uinIds.length === 0) {
    const storedUinIds = getStorage('uin_ids');
    if (storedUinIds) {
      try {
        uinIds = JSON.parse(storedUinIds);
      } catch (e) {
        // If parsing fails, keep uinIds as empty array
        console.error('Error parsing stored UIN IDs:', e);
      }
    }
  }
  
  // Store parameters in localStorage if they exist
  if (clientId) {
    setStorage('client_id', clientId);
  }
  
  if (uinIds.length > 0) {
    setStorage('uin_ids', JSON.stringify(uinIds));
  }
  
  // Remove parameters from URL only if they were present
  if (params.get('client_id') || params.get('uin_ids')) {
    // Remove the parameters
    params.delete('client_id');
    params.delete('uin_ids');
    
    // Create new URL without the parameters
    const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
    
    // Update browser history without reloading the page
    window.history.replaceState({}, document.title, newUrl);
  }

  // Return the extracted values so they can be used immediately
  // Also return a validation status for client_id
  return {
    clientId: clientId || null,
    uinIds: uinIds.length > 0 ? uinIds : null,
    isValid: clientId !== null && clientId !== 'null' && clientId !== ''
  };
}; 